import React from 'react';
import { Card, CardProps, SxProps, Theme } from '@mui/material';
import { motion } from 'framer-motion';
import { cardVariants } from '../../animations/variants';

interface AnimatedCardProps extends Omit<CardProps, 'sx'> {
  children: React.ReactNode;
  hoverable?: boolean;
  glow?: boolean;
  delay?: number;
  sx?: SxProps<Theme>;
}

const AnimatedCard: React.FC<AnimatedCardProps> = ({
  children,
  hoverable = true,
  glow = false,
  delay = 0,
  sx = {},
  ...props
}) => {
  return (
    <motion.div
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      whileHover={hoverable ? "hover" : undefined}
      transition={{ delay }}
    >
      <Card
        component={motion.div}
        sx={{
          position: 'relative',
          overflow: 'hidden',
          ...(glow && {
            '&::before': {
              content: '""',
              position: 'absolute',
              top: '-50%',
              left: '-50%',
              width: '200%',
              height: '200%',
              background: 'conic-gradient(from 0deg, transparent, #00D4FF, transparent, #FF00FF, transparent)',
              animation: 'rotate 4s linear infinite',
              opacity: 0.3,
              zIndex: 0,
            },
            '@keyframes rotate': {
              '0%': { transform: 'rotate(0deg)' },
              '100%': { transform: 'rotate(360deg)' },
            },
          }),
          ...sx,
        }}
        {...props}
      >
        <motion.div
          style={{ position: 'relative', zIndex: 1 }}
          animate={glow ? { opacity: [0.8, 1, 0.8] } : {}}
          transition={glow ? { duration: 2, repeat: Infinity, ease: 'easeInOut' } : {}}
        >
          {children}
        </motion.div>
      </Card>
    </motion.div>
  );
};

export default AnimatedCard;